/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalendarDay2
 */
export interface CalendarDay2 {
    /**
     * 
     * @type {string}
     * @memberof CalendarDay2
     */
    day: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarDay2
     */
    name: string;
}

/**
 * Check if a given object implements the CalendarDay2 interface.
 */
export function instanceOfCalendarDay2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "day" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CalendarDay2FromJSON(json: any): CalendarDay2 {
    return CalendarDay2FromJSONTyped(json, false);
}

export function CalendarDay2FromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarDay2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'day': json['day'],
        'name': json['name'],
    };
}

export function CalendarDay2ToJSON(value?: CalendarDay2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'day': value.day,
        'name': value.name,
    };
}

